/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { time_tracking_ApproveTimeEntriesRequest } from '../models/time_tracking_ApproveTimeEntriesRequest';
import type { time_tracking_BreakEntryResponse } from '../models/time_tracking_BreakEntryResponse';
import type { time_tracking_BulkStatusResponse } from '../models/time_tracking_BulkStatusResponse';
import type { time_tracking_ClockedInCountResponse } from '../models/time_tracking_ClockedInCountResponse';
import type { time_tracking_ClockInRequest } from '../models/time_tracking_ClockInRequest';
import type { time_tracking_ClockOutRequest } from '../models/time_tracking_ClockOutRequest';
import type { time_tracking_CreateBreakEntryRequest } from '../models/time_tracking_CreateBreakEntryRequest';
import type { time_tracking_CreateManualEntryRequest } from '../models/time_tracking_CreateManualEntryRequest';
import type { time_tracking_EndBreakRequest } from '../models/time_tracking_EndBreakRequest';
import type { time_tracking_RejectTimeEntriesRequest } from '../models/time_tracking_RejectTimeEntriesRequest';
import type { time_tracking_StartBreakRequest } from '../models/time_tracking_StartBreakRequest';
import type { time_tracking_SubmitForApprovalRequest } from '../models/time_tracking_SubmitForApprovalRequest';
import type { time_tracking_TimeEntryListResponse } from '../models/time_tracking_TimeEntryListResponse';
import type { time_tracking_TimeEntryResponse } from '../models/time_tracking_TimeEntryResponse';
import type { time_tracking_TimesheetSummaryResponse } from '../models/time_tracking_TimesheetSummaryResponse';
import type { time_tracking_UpdateBreakEntryRequest } from '../models/time_tracking_UpdateBreakEntryRequest';
import type { time_tracking_UpdateTimeEntryRequest } from '../models/time_tracking_UpdateTimeEntryRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TimeEntriesService {
    /**
     * List time entries with filters
     * Get paginated list of time entries with optional filters
     * @param employeeId Filter by employee ID
     * @param fromDate Filter from date (YYYY-MM-DD)
     * @param toDate Filter to date (YYYY-MM-DD)
     * @param status Filter by status
     * @param limit Maximum number of results (default: 20, max: 100)
     * @param offset Offset for pagination (default: 0)
     * @returns time_tracking_TimeEntryListResponse OK
     * @throws ApiError
     */
    public static getApiV1TimeEntries(
        employeeId?: string,
        fromDate?: string,
        toDate?: string,
        status?: 'OPEN' | 'SUBMITTED' | 'APPROVED' | 'REJECTED',
        limit?: number,
        offset?: number,
    ): CancelablePromise<time_tracking_TimeEntryListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/time-entries',
            query: {
                'employee_id': employeeId,
                'from_date': fromDate,
                'to_date': toDate,
                'status': status,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid request parameters`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to list time entries`,
            },
        });
    }
    /**
     * Create a manual time entry
     * Create a manual time entry with specified clock-in/out times. Employees can only create entries for themselves; admins can create for any employee.
     * @param request Manual entry parameters
     * @returns time_tracking_TimeEntryResponse Created
     * @throws ApiError
     */
    public static postApiV1TimeEntries(
        request: time_tracking_CreateManualEntryRequest,
    ): CancelablePromise<time_tracking_TimeEntryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/time-entries',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token or not authorized`,
                500: `Failed to create manual entry`,
            },
        });
    }
    /**
     * Delete a time entry
     * Soft delete a time entry (only OPEN or REJECTED entries can be deleted)
     * @param id Time entry ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1TimeEntries(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/time-entries/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing time entry ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Time entry not found`,
                409: `Time entry is not in a deletable status`,
                500: `Failed to delete time entry`,
            },
        });
    }
    /**
     * Get time entry by ID
     * Get a single time entry by ID with break details
     * @param id Time entry ID
     * @returns time_tracking_TimeEntryResponse OK
     * @throws ApiError
     */
    public static getApiV1TimeEntries1(
        id: string,
    ): CancelablePromise<time_tracking_TimeEntryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/time-entries/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing time entry ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Time entry not found`,
                500: `Failed to get time entry`,
            },
        });
    }
    /**
     * Update a time entry
     * Update an existing time entry with optimistic locking
     * @param id Time entry ID
     * @param request Updated time entry data
     * @returns time_tracking_TimeEntryResponse OK
     * @throws ApiError
     */
    public static putApiV1TimeEntries(
        id: string,
        request: time_tracking_UpdateTimeEntryRequest,
    ): CancelablePromise<time_tracking_TimeEntryResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/time-entries/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Time entry not found`,
                409: `Time entry was modified by another user or is not in editable status`,
                500: `Failed to update time entry`,
            },
        });
    }
    /**
     * Create a break entry for a time entry
     * Create a new break entry with explicit start and end times for an existing time entry
     * @param id Time entry ID
     * @param request Break entry parameters
     * @returns time_tracking_BreakEntryResponse Created
     * @throws ApiError
     */
    public static postApiV1TimeEntriesBreaks(
        id: string,
        request: time_tracking_CreateBreakEntryRequest,
    ): CancelablePromise<time_tracking_BreakEntryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/time-entries/{id}/breaks',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Time entry not found`,
                409: `Time entry is not in OPEN status`,
                500: `Failed to create break entry`,
            },
        });
    }
    /**
     * Delete a break entry
     * Soft delete a break entry (only from OPEN time entries)
     * @param id Time entry ID
     * @param breakId Break entry ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1TimeEntriesBreaks(
        id: string,
        breakId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/time-entries/{id}/breaks/{breakId}',
            path: {
                'id': id,
                'breakId': breakId,
            },
            errors: {
                400: `Invalid or missing break entry ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Break entry not found`,
                409: `Time entry is not in OPEN status`,
                500: `Failed to delete break entry`,
            },
        });
    }
    /**
     * Update a break entry
     * Update an existing break entry with new start/end times
     * @param id Time entry ID
     * @param breakId Break entry ID
     * @param request Updated break entry data
     * @returns time_tracking_BreakEntryResponse OK
     * @throws ApiError
     */
    public static putApiV1TimeEntriesBreaks(
        id: string,
        breakId: string,
        request: time_tracking_UpdateBreakEntryRequest,
    ): CancelablePromise<time_tracking_BreakEntryResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/time-entries/{id}/breaks/{breakId}',
            path: {
                'id': id,
                'breakId': breakId,
            },
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Break entry or time entry not found`,
                409: `Time entry is not in OPEN status or optimistic lock failed`,
                500: `Failed to update break entry`,
            },
        });
    }
    /**
     * Get active time entry for the authenticated employee
     * Returns the currently active (open) time entry for the authenticated employee, or 404 if not clocked in
     * @returns time_tracking_TimeEntryResponse OK
     * @throws ApiError
     */
    public static getApiV1TimeEntriesActive(): CancelablePromise<time_tracking_TimeEntryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/time-entries/active',
            errors: {
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `No active time entry or employee not found`,
                500: `Failed to get active time entry`,
            },
        });
    }
    /**
     * Approve time entries
     * Transition SUBMITTED time entries to APPROVED status for a date range
     * @param request Approve parameters
     * @returns time_tracking_BulkStatusResponse OK
     * @throws ApiError
     */
    public static postApiV1TimeEntriesApprove(
        request: time_tracking_ApproveTimeEntriesRequest,
    ): CancelablePromise<time_tracking_BulkStatusResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/time-entries/approve',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `No entries found for the specified range`,
                500: `Failed to approve time entries`,
            },
        });
    }
    /**
     * End a break
     * End an active break, calculating the duration. Supply the optional client_capture_id to make the call idempotent: a replay by the same employee returns the ORIGINAL break entry with the same 200 status and writes nothing.
     * @param request End break parameters
     * @returns time_tracking_BreakEntryResponse OK
     * @throws ApiError
     */
    public static postApiV1TimeEntriesBreakEnd(
        request: time_tracking_EndBreakRequest,
    ): CancelablePromise<time_tracking_BreakEntryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/time-entries/break/end',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Break entry not found, or a replayed capture key points at a deleted break entry`,
                409: `No active break in progress, or the capture key was claimed by a different user or operation. Allowed while the organisation has turned time tracking off, so an open break can always be ended`,
                500: `Failed to end break`,
            },
        });
    }
    /**
     * Start a break
     * Start a new break for an active time entry. Only one break can be active at a time. Supply the optional client_capture_id to make the call idempotent: a replay by the same employee returns the ORIGINAL break entry with the same 201 status and writes nothing.
     * @param request Start break parameters
     * @returns time_tracking_BreakEntryResponse Created
     * @throws ApiError
     */
    public static postApiV1TimeEntriesBreakStart(
        request: time_tracking_StartBreakRequest,
    ): CancelablePromise<time_tracking_BreakEntryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/time-entries/break/start',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Time entry not found, or a replayed capture key points at a deleted break entry`,
                409: `A break is already in progress, the time entry is not open, or the capture key was claimed by a different user or operation; TIME_TRACKING_DISABLED when the organisation has turned time tracking off`,
                500: `Failed to start break`,
            },
        });
    }
    /**
     * Clock in an employee
     * Start a new time entry by clocking in. Checks for existing open entries. Supply the optional client_capture_id to make the call idempotent: a replay by the same employee returns the ORIGINAL time entry with the same 201 status and writes nothing.
     * @param request Clock-in parameters
     * @returns time_tracking_TimeEntryResponse Created
     * @throws ApiError
     */
    public static postApiV1TimeEntriesClockIn(
        request: time_tracking_ClockInRequest,
    ): CancelablePromise<time_tracking_TimeEntryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/time-entries/clock-in',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Replayed capture key points at a deleted time entry`,
                409: `Employee is already clocked in, or the capture key was claimed by a different user or operation; TIME_TRACKING_DISABLED when the organisation has turned time tracking off`,
                500: `Failed to clock in`,
            },
        });
    }
    /**
     * Clock out an employee
     * End a time entry by clocking out. Automatically ends any active breaks. Supply the optional client_capture_id to make the call idempotent: a replay by the same employee returns the ORIGINAL time entry with the same 200 status and writes nothing.
     * @param request Clock-out parameters
     * @returns time_tracking_TimeEntryResponse OK
     * @throws ApiError
     */
    public static postApiV1TimeEntriesClockOut(
        request: time_tracking_ClockOutRequest,
    ): CancelablePromise<time_tracking_TimeEntryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/time-entries/clock-out',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Time entry not found, or a replayed capture key points at a deleted time entry`,
                409: `Time entry is not in OPEN status, or the capture key was claimed by a different user or operation. Allowed while the organisation has turned time tracking off, so an open entry can always be closed`,
                500: `Failed to clock out`,
            },
        });
    }
    /**
     * Count the employees clocked in right now
     * Returns how many employees of the organisation have an open time entry (no clock-out yet), an entry left open from an earlier day included. The settings page shows it before an admin switches time tracking off; those employees can still clock out. Admin only.
     * @returns time_tracking_ClockedInCountResponse OK
     * @throws ApiError
     */
    public static getApiV1TimeEntriesClockedInCount(): CancelablePromise<time_tracking_ClockedInCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/time-entries/clocked-in-count',
            errors: {
                401: `Authentication required`,
                403: `Not an admin, or organization ID not found in token`,
                500: `Failed to count clocked-in employees`,
            },
        });
    }
    /**
     * Reject time entries
     * Transition SUBMITTED time entries to REJECTED status for a date range with a reason
     * @param request Reject parameters
     * @returns time_tracking_BulkStatusResponse OK
     * @throws ApiError
     */
    public static postApiV1TimeEntriesReject(
        request: time_tracking_RejectTimeEntriesRequest,
    ): CancelablePromise<time_tracking_BulkStatusResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/time-entries/reject',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `No entries found for the specified range`,
                500: `Failed to reject time entries`,
            },
        });
    }
    /**
     * Submit time entries for approval
     * Transition OPEN time entries to SUBMITTED status for a date range
     * @param request Submit parameters
     * @returns time_tracking_BulkStatusResponse OK
     * @throws ApiError
     */
    public static postApiV1TimeEntriesSubmit(
        request: time_tracking_SubmitForApprovalRequest,
    ): CancelablePromise<time_tracking_BulkStatusResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/time-entries/submit',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `No entries found for the specified range`,
                500: `Failed to submit for approval`,
            },
        });
    }
    /**
     * Get timesheet summary
     * Get a timesheet summary for an employee for a date range with daily breakdown
     * @param employeeId Employee ID
     * @param fromDate Start date (YYYY-MM-DD)
     * @param toDate End date (YYYY-MM-DD)
     * @returns time_tracking_TimesheetSummaryResponse OK
     * @throws ApiError
     */
    public static getApiV1TimeEntriesTimesheet(
        employeeId: string,
        fromDate: string,
        toDate: string,
    ): CancelablePromise<time_tracking_TimesheetSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/time-entries/timesheet',
            query: {
                'employee_id': employeeId,
                'from_date': fromDate,
                'to_date': toDate,
            },
            errors: {
                400: `Missing or invalid parameters`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to get timesheet summary`,
            },
        });
    }
}
